// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AdminCourseEdit-occations[data-v-13c534bb]{border:1px solid #c4aa74;background:#f0e0be;margin:5px;padding:14px}.AdminCourseEdit-occation[data-v-13c534bb]{border-bottom:1px dashed #c4aa74;padding:14px 0 0 0}legend[data-v-13c534bb]{font-weight:600;font-size:13px;text-align:left;text-transform:uppercase}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
